import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Constants } from '../../constants/constants';
import { CommonDataService } from '../../services/common-data.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'decimalPrecision',
  standalone: true,
  pure: true
})
export class DecimalPrecisionPipe implements PipeTransform {

  constructor(private readonly commonDataService: CommonDataService,
    private translateService: TranslateService
  ) {}

  transform(value: number | string | null | undefined, overridePrecision?: number): string {
    if (value === null || value === undefined || value === Constants.EMPTY_STRING) {
      return Constants.EMPTY_STRING;
    }

    const numericValue = typeof value === 'string' ? parseFloat(value.trim()) : value;
    if (isNaN(numericValue)) {
      return value.toString();
    }

    const precision = overridePrecision ?? this.commonDataService.getDecimalPrecision();
    const currentLang = this.translateService.currentLang || this.translateService.defaultLang || Constants.LANGUAGE_EN_US;

    // Zero is neither positive nor negative, so avoid rendering "-0.00"
    const normalizedValue = Number(numericValue.toFixed(precision)) === 0 ? 0 : numericValue;

    return new Intl.NumberFormat(currentLang, {
      style: 'decimal',
      minimumFractionDigits: precision,
      maximumFractionDigits: precision
    }).format(normalizedValue);
  }
}
